import Tools from './tools';

export default class Nav {
    constructor() {
        // Nav

        this.burger();
    }

    burger() {
        const btn = document.querySelector('.nav__burger');
        const nav = document.querySelector('.nav');
        if (btn && nav) {
            btn.addEventListener('click', () => {
                nav.classList.toggle('js-open');

                if (nav.classList.contains('js-open')) {
                    btn.classList.add('cta');
                    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192s192-86 192-192Z"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M320 320L192 192m0 128l128-128"/></svg> fermer';
                } else {
                    btn.classList.remove('cta');
                    btn.innerHTML = 'menu';
                }
            });
        }
    }
}